module.exports = __webpack_public_path__ + "static/2_1_search-1_IS-c3ab9d602d53b8a3c2fec96a5d2eeb49.svg";